import { AxiosResponse, AxiosError } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSyabanRenrakuhyoGetReq,
  TSyabanRenrakuhyoGetRes,
  TSyabanRenrakuhyoPrintReq,
} from "./TSyabanRenrakuhyo"

/**
 * 車番連絡表印刷画面に対するAPIリクエスト用サービス
 *
 * @export
 * @class SyabanRenrakuhyoService
 * @extends {ConnectApi}
 */
export default class SyabanRenrakuhyoService extends ConnectApi {
  /**
   * 車番連絡表一覧取得
   *
   * @param {TSyabanRenrakuhyoGetReq} params
   * @param {(param: TApiResponse<TSyabanRenrakuhyoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TSyabanRenrakuhyoGetRes[]>) => any} reject
   * @memberof syabanRenrakuhyoService
   */
  getList = async (
    params: TSyabanRenrakuhyoGetReq,
    resolve?: (param: TApiResponse<TSyabanRenrakuhyoGetRes[]>) => any,
    reject?: (param: TApiResponse<TSyabanRenrakuhyoGetRes[]> | undefined) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<TApiResponse<TSyabanRenrakuhyoGetRes[]>> =
        await this.getInner(`/order/syabanrenrakuhyo`, params)
      return res.data
    } catch (err) {
      if (typeof err !== "object" || err == null) throw err
      const error = err as TApiResponse<TSyabanRenrakuhyoGetRes[]>
      throw reject ? reject(error) : error
    }
  }

  /**
   * 車番連絡表印刷
   *
   * @param {TSyabanRenrakuhyoPrintReq} params
   * @memberof syabanRenrakuhyoService
   */
  printSyabanRenrakuhyo = async (
    params: TSyabanRenrakuhyoPrintReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G040702`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
